import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../components/shared/PageTitle';

const TABS = [
  { key: 'profile', path: 'profile' },
  { key: 'products', path: 'products' },
  { key: 'notifications', path: 'notifications' },
  { key: 'emailSender', path: 'email-sender' },
] as const;

export default function TeamMemberSettings() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <PageTitle title={t('teamSettings.title')} />
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('teamSettings.title')}</h1>
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <nav className="flex border-b border-gray-200 overflow-x-auto">
            {TABS.map(({ key, path }) => (
              <NavLink
                key={key}
                to={path}
                className={({ isActive }) =>
                  `px-6 py-4 text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? 'border-b-2 border-[#4339A0] text-[#4339A0]'
                      : 'text-gray-600 hover:text-gray-900'
                  }`
                }
              >
                {t(`teamSettings.tabs.${key}`)}
              </NavLink>
            ))}
          </nav>
          <div className="p-6">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
